import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import { ChatService, Message } from "src/app/chat.service";
import { HomeService } from "src/app/services/home.service";
import { ToggleService } from "src/app/services/toggle.service";
import { MatDialog } from "@angular/material";
import { EndLiveChatComponent } from "../body/end-live-chat/end-live-chat.component";
declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  currentPage:any = 'home';
  @Output() expandChatbot = new EventEmitter<boolean>();

  constructor(private readonly toggleService: ToggleService,
    private chat: ChatService, private homeService: HomeService, public dialog: MatDialog) {}
  @Output() toggleChatBotEv = new EventEmitter<number>();
  @Output() clearMessages = new EventEmitter<any>();
  @Output() sendHelloMessageEv = new EventEmitter<void>();

  @Input() chatbot_lang;
  closeCount:number = 0
  ngOnInit() {
    console.log('header agentSwitch ', localStorage.getItem('agentSwitch'))
    this.homeService.homeHistory$.subscribe(value => {
      this.currentPage = value;
    });
  }
  clearChatBot(num: number) {
        this.clearMessages.emit();
        this.closeCount=this.closeCount+1 
        this.toggleService.toggleChatbot(0);
      
  }
  toggleChatBot(num: number) {
    this.expandChatbot.emit(false); // trigger expansion
    this.toggleService.toggleChatbot(num);
    $('.chatbot-toggle-icon').show();

      localStorage.setItem('helpMessage', 'removed');
      const helpMessage = localStorage.getItem('helpMessage');
      window.parent.postMessage({ type: 'localStorageData', helpMessage }, '*');
    parent.postMessage({ open : false }, '*');
  }

  callHomePage(){
    console.log('home page called')
    if (localStorage.getItem('agentSwitch') == 'true') {
      this.openEndChatDialog()
    } else {
      this.homeService.setCurrentPage('home');
    }

  }
  openEndChatDialog(): void {
    console.log('testing')
    const dialogRef = this.dialog.open(EndLiveChatComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        localStorage.setItem('agentSwitch', 'false')
        this.clearMessages.emit();
        this.homeService.setCurrentPage('home');
      } else {
        console.log('Chat close cancelled');
      }
    });
  }

}
